import { get_token } from "@/router";

const STATUS_TITLES = {
  accepted: "Invitation accepted",
  rejected: "Invitation declined",
  error: "Could not update invitation",
};

const STATUS_MESSAGES = {
  accepted: "Your organisation access has been updated.",
  rejected: "You declined this organisation invitation.",
};

const STATUS_ICONS = {
  accepted: "bi bi-check-circle",
  rejected: "bi bi-x-circle",
  error: "bi bi-exclamation-circle",
};

export default {
  data() {
    return ({
      is_submitting: false,
      has_responded: false,
      response_status: "",
      response_message: "",
    });
  },
  computed: {
    invitation_token() {
      return this.$route.query.invitation_token || this.$route.query.token || this.$route.params.token || "";
    },
    has_invite_reference() {
      return !!this.invitation_token;
    },
    status_title() {
      if (!this.has_invite_reference) return "Invite link is incomplete";
      return STATUS_TITLES[this.response_status] || "You have been invited";
    },
    status_message() {
      if (this.response_message) return this.response_message;
      if (!this.has_invite_reference) return "Please use the full invitation link from your email.";
      return STATUS_MESSAGES[this.response_status] ||
        "Accept to join the organisation, or reject if this invite was not meant for you.";
    },
    status_icon() {
      if (!this.has_invite_reference) return STATUS_ICONS.error;
      return STATUS_ICONS[this.response_status] || "bi bi-envelope-open";
    },
  },
  methods: {
    continue_after_response() {
      if (this.response_status === "rejected") {
        window.open("", "_self");
        window.close();
        this.response_message = "You can close this tab.";
        return;
      }

      this.$router.push("/sign_in_finale");
    },
    respond_to_invite(action) {
      if (!this.has_invite_reference) return;

      this.is_submitting = true;
      const display_status = action === "accept" ? "accepted" : "rejected";
      const payload = {
        action,
        invitation_token: this.invitation_token,
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/respond_organization_invite/`,
        data: JSON.stringify(payload),
        headers: {
          ...(get_token() ? { Authorization: `Token ${get_token()}` } : {}),
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.handle_invite_response_success(response, display_status, action);
        },
        error: (xhr) => {
          this.response_status = "error";
          this.response_message = xhr?.responseJSON?.message || "Please try again or contact the organisation admin.";
        },
        complete: () => {
          this.is_submitting = false;
        },
      });
    },
    handle_invite_response_success(response, display_status, action) {
      if (response?.status !== "success") {
        this.set_invite_response_error(response?.message);
        return;
      }

      this.set_invite_response_success(display_status, response?.message);
      this.redirect_accepted_invite(action);
    },
    set_invite_response_success(display_status, message) {
      this.response_status = display_status;
      this.response_message = message || "";
      this.has_responded = true;
    },
    redirect_accepted_invite(action) {
      if (action !== "accept") return;
      this.$router.push({
        name: "organization_invite_setup",
        query: {
          invitation_token: this.invitation_token,
        },
      });
    },
    set_invite_response_error(message) {
      this.response_status = "error";
      this.response_message = message || "Please try again or contact the organisation admin.";
    },
  },
};
